'use strict';

var icon = require('../../../../../../../../../../_virtual/icon4.cjs');

var hasRequiredIcon;

function requireIcon () {
	if (hasRequiredIcon) return icon.__exports;
	hasRequiredIcon = 1;

	var ICON_VARIANTS = /*#__PURE__*/ function(ICON_VARIANTS) {
	    ICON_VARIANTS["noStyle"] = "noStyle";
	    ICON_VARIANTS["circular"] = "circular";
	    ICON_VARIANTS["rectangular"] = "rectangular";
	    return ICON_VARIANTS;
	}({});

	icon.__exports.ICON_VARIANTS = ICON_VARIANTS;
	
	return icon.__exports;
}

exports.__require = requireIcon;
//# sourceMappingURL=icon.cjs.map
